import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HbNotification } from '../notification';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'hb-notification-container',
  templateUrl: './notification-container.component.html',
  styleUrls: ['./notification-container.component.scss'],
})
export class NotificationContainerComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<boolean> = new Subject();
  notifications = new Array<HbNotification>();

  constructor(public notificationService: NotificationService) {}

  ngOnInit() {
    this.notificationService.notifications.pipe(
      takeUntil(this.unsubscribe))
      .subscribe(x => {
        this.notifications = x;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  dismissAll(): void {
    const hasNotifications = this.notificationService.hasNotifications();
    if (hasNotifications) {
      this.notificationService.clearNotifications();
    }
  }
}
